import * as Tokens from '../utils/DesignTokens/theme/purple/tokens';
import prepareTheme from './prepareTheme';
const CompleteTheme = prepareTheme(Tokens);
const purpleTheme = CompleteTheme;
export default purpleTheme;
//# sourceMappingURL=purpleTheme.js.map